import { Api } from "./api"

export class CollectiveReportApi extends Api {
  constructor() {
    super('collective_reports', [],{prefix: 'guest_invitations/report'})
  }
}
